export default "__VITE_ASSET__4d760bb8__"